import { popUp } from "./popUp";

/*
    * Confirm
    * Opens a confirm message
    *
    *
    * id - ID of the window created
    * okText - text shown on OK button
    * okClick - function you want to execute on ok
    * cancelText - text shown on Cancel button
    * cancelClick - function you want to execute on cancel
    * message - Message you want to display to user
    *
    * Defaults:
    * okText = "OK"
    * cancelText = "Cancel"
    *
    * Ends up calling the z.controls.popUp() function
    *
    */
export function confirm(options) {
    options = options || {};

    options.guts = options.guts || options.message;
    options.title = options.title;

    options.keepContentBox = true;
    options.overlay = true;
    options.buttons = [
        {
            name: options.okText || "OK",
            clickEvent: options.okClick
        },
        {
            name: options.cancelText || "Cancel",
            clickEvent: options.cancelClick
        }
    ];

    options.close = options.cancelClick;

    return popUp(options);
}
